<div>
    <app-receipt-options-html *ngIf="receiptType != 0" [businessId]="businessId"
        [receiptType]="receiptType"></app-receipt-options-html>
</div>